module.exports = __webpack_public_path__ + "static/media/team-graph-placeholder.b116c4b2.svg";